import { createStore } from './createStore';

const projectFormStoreConfig = {
  id: 'projectFormStore',
  initialState: {
    errors: {},
    title: '',
    client: null,
    owner: null,
    site: null,
    members: null,
    scheduledStartDate: null,
    dueDate: null,
    status: 'Planned',
    addMembers: [],
    deleteMembers: [],
    addMilestones: [],
    addTasks: [],
    associateTimer: false,
    preventScroll: false,
    showToClient: false,
    selectedFormTemplate: null
  },
  methods: (set, get) => ({
    setTitle: (title) => {
      set({ title });
    },
    setClient: (client) => {
      set({ client });
    },
    setOwner: (owner) => {
      set({ owner });
    },
    setSite: (site) => {
      set({ site });
    },
    setMembers: (members) => {
      set({ members });
    },
    setScheduledStartDate: (scheduledStartDate) => {
      set({ scheduledStartDate });
    },
    setDueDate: (dueDate) => {
      set({ dueDate });
    },
    setStatus: (status) => {
      set({ status });
    },
    setAddMembers: (addMembers) => {
      set({ addMembers });
    },
    setDeleteMembers: (deleteMembers) => {
      set({ deleteMembers });
    },
    setAddMilestones: (addMilestones) => {
      set({ addMilestones });
    },
    setAddTasks: (addTasks) => {
      set({ addTasks });
    },
    setAssociateTimer: (associateTimer) => {
      set({ associateTimer });
    },
    setPreventScroll: (bool) => {
      set({ preventScroll: bool });
    },
    setShowToClient: (bool) => {
      set({ showToClient: bool });
    },
    setErrors: (errorData) => {
      set({ errors: errorData });
    },
    setSelectedFormTemplate: (selectedFormTemplate) => {
      set({ selectedFormTemplate });
    },
    handleProjectChange: (updatedProject) => {
      const data = get();
      set({ ...data, ...updatedProject });
    },
    resetProjectForm: () => {
      set({
        errors: {},
        title: '',
        client: null,
        owner: null,
        site: null,
        members: null,
        scheduledStartDate: null,
        dueDate: null,
        status: 'Planned',
        addMembers: [],
        deleteMembers: [],
        addMilestones: [],
        addTasks: [],
        associateTimer: false,
        preventScroll: false,
        showToClient: false,
        selectedFormTemplate: []
      });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true
  }
};

export const useProjectFormStore = createStore(projectFormStoreConfig);
